import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "data-test": "stat-label",
  class: "stat-tile__label"
}
const _hoisted_2 = {
  key: 0,
  "data-test": "stat-loading",
  class: "mt-1.5 h-7 w-20 animate-pulse rounded bg-gray-200"
}
const _hoisted_3 = {
  key: 0,
  "data-test": "stat-caption",
  class: "stat-tile__caption"
}


export default {
  __name: 'StatTile',
  props: {
  label: { type: String, required: true },
  value: { type: String, default: '' },
  caption: { type: String, default: '' },
  compact: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  flush: { type: Boolean, default: false }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stat-tile", __props.flush && 'stat-tile--flush'])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.label), 1),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            "data-test": "stat-value",
            class: _normalizeClass(["stat-tile__value", __props.compact && 'stat-tile__value--compact'])
          }, _toDisplayString(__props.value), 3),
          (__props.caption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.caption), 1))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}
}

}